import React from 'react';
import { Layout } from '../components';
import Search from '../components/search';

const searchIndices = [{ name: 'Pages', title: 'Pages' }];

const NotFoundPage = () => (
  <Layout>
    <div className="container">
      <section>
        <h1>Siden eksiterer ikke</h1>
        <p>Siden som du forsøger at se findes ikke.</p>
        <p>Brug søgefunktionen til at finde det du leder efter.</p>
        <hr data-margin="small" style={{ marginLeft: 0 }} />
        <Search indices={searchIndices} />
      </section>
    </div>
  </Layout>
);

export default NotFoundPage;
